// Frases do produto («O que queres escrever?»). Código partilhado entre a loja e o servidor (worker/orders.ts):
// a loja usa-o para mostrar o resumo e o servidor usa-o para reconstruir o texto final a partir da configuração autorizada.
// Opção pública: { id, title, image, mode: "phrase" | "name_only", template, articles: [{ id, label }] }.
export const PHRASE_NAME_RE = /^[A-Za-zÀ-ÿ' -]*$/;
export const DEFAULT_PHRASE_MAX = 24;

// Espaços repetidos viram um só; acentos e hífenes ficam como estão.
export const normalizeName = (s) => String(s ?? "").trim().replace(/\s+/g, " ");

export const activePhrases = (product) => (product?.phrases?.options?.length ? product.phrases : null);
export const phraseOption = (product, id) => activePhrases(product)?.options.find((o) => o.id === id) ?? null;
export const needsArticle = (option) => option?.mode === "phrase" && (option.articles?.length ?? 0) > 0 && String(option.template).includes("{artigo}");

/** Texto final de uma frase, sem validar (usado no resumo enquanto a cliente escreve). */
export const phraseText = (option, articleId, name) => {
  const n = normalizeName(name);
  if (!option) return "";
  const label = option.articles?.find((a) => a.id === articleId)?.label ?? "";
  const tpl = option.mode === "name_only" ? "{nome}" : option.template;
  return tpl.replace("{artigo}", label).replace("{nome}", n).replace(/\s+/g, " ").trim();
};

/** Valida a escolha contra a configuração e devolve { phrase } (com o texto reconstruído) ou { error }. */
export const resolvePhrase = (phrases, sel) => {
  const opt = phrases?.options?.find((o) => o.id === sel?.optionId);
  if (!opt) return { error: "a opção de frase escolhida já não está disponível." };
  const name = normalizeName(sel.name);
  if (!name) return { error: "indica o nome a colocar." };
  if (name.length > phrases.maxLength) return { error: `o nome pode ter até ${phrases.maxLength} caracteres.` };
  if (!PHRASE_NAME_RE.test(name)) return { error: "usa apenas letras, espaços ou hífen no nome." };
  let article = null;
  if (needsArticle(opt)) {
    article = opt.articles.find((a) => a.id === sel.articleId);
    if (!article) return { error: "escolhe «do» ou «da»." };
  } else if (sel.articleId) return { error: "esta opção não leva «do» / «da»." };
  return {
    phrase: {
      option_id: opt.id, option_title: opt.title, mode: opt.mode,
      article_id: article?.id ?? null, article: article?.label ?? null,
      name, text: phraseText(opt, article?.id ?? null, name),
    },
  };
};
